<template>
  <div class="check-plateform">
    <!--标题-->
    <div class="region-title">审核平台</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="170px" :rules="rules" ref="ruleForm">
        <el-form-item label="平台号:">
          <span>{{ basicInfo.code }}</span>
        </el-form-item>
        <el-form-item label="平台名称:"> {{ basicInfo.name }} </el-form-item>
        <el-form-item label="公司名称:"> {{ basicInfo.companyName }} </el-form-item>
        <el-form-item label="开票资质:">
          <!-- {{ basicInfo.invoice == 0 ? '无' : '有' }}  -->
          <el-switch v-model="basicInfo.invoice" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" disabled></el-switch>
        </el-form-item>
        <el-form-item label="收款账号:" v-show="basicInfo.invoice"> {{ basicInfo.collectionAccount }} </el-form-item>
        <el-form-item label="户名:" v-show="basicInfo.invoice"> {{ basicInfo.accountName }} </el-form-item>
        <el-form-item label="开户行:" v-show="basicInfo.invoice"> {{ basicInfo.bank }} </el-form-item>
        <el-form-item label="营业执照:" v-show="basicInfo.invoice">
          <el-image style="max-width:200px" v-if="basicInfo.licenseUrl !== undefined && basicInfo.licenseUrl !== ''" class="yingye" :src="basicInfo.licenseUrl"
            :preview-src-list="[basicInfo.licenseUrl]"></el-image>
        </el-form-item>
        <el-form-item label="支付方式:">
          <el-select v-model="basicInfo.paymentType" placeholder="请选择" class="customer-select">
            <!-- <el-option label="码支付" value="CODE"></el-option> -->
            <el-option label="余额支付" value="BALANCE"></el-option>
            <el-option label="在线支付" value="ONLINE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="微信二维码:">
          <el-image style="max-width:200px" v-if="basicInfo.qrCode !== undefined && basicInfo.qrCode !== ''" class="yingye" :src="basicInfo.qrCode" :preview-src-list="[basicInfo.qrCode]"></el-image>
        </el-form-item>
        <el-form-item label="是否为淘宝平台:">
          <el-switch v-model="basicInfo.tbOrder" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否支持生成核销码:">
          <el-switch v-model="basicInfo.supportVerificationCode" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否为抖音平台:">
          <el-switch v-model="basicInfo.dyOrder" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否为获客平台:">
          <el-switch v-model="basicInfo.acquisition" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否设置代理价格:">
          <el-switch v-model="basicInfo.agentPrice" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否开通云底片:">
          <el-switch v-model="basicInfo.cloudPhotographicPlate" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否开通预约服务:">
          <el-switch v-model="basicInfo.reservationService" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否支持APP:">
          <el-switch v-model="basicInfo.supportApp" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
          <span style="margin-left: 10px;color:red;">注：仅自营店铺可打开此开关</span>
        </el-form-item>
        <el-form-item label="是否为渠道客户:">
          <el-switch v-model="basicInfo.channelCustomer" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" @change="customerChange"></el-switch>
          <span style="margin-left: 10px;color:red;font-size: 12px;">注:1.余额支付并开启，需要配置第三方的小程序名称，ID，密钥和图标，如鼎星；2.在线支付并开启，需要配置第三方小程序名称，ID，密
            钥和图标，商户ID，密钥路径，证书序列号，APPlv3密钥。C端客户支付到B端微信账户，后台自动扣B端平台余额的金额。如：冉逸</span>
        </el-form-item>
        <el-form-item label="是否为余额自动支付:">
          <el-switch v-model="basicInfo.automaticPayment" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
          <span style="margin-left: 10px;color:red;">注:开启后产品可生成余额支付码和余额支付电子卡券，C端客户使用码券提交的订单平台余额自动支付</span>
        </el-form-item>
        <el-form-item label="是否自定义小程序首页:">
          <el-switch v-model="basicInfo.diyHomepage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
          <span style="margin-left: 10px;color:red;">注：开启后平台可自行个性化设置小程序首页界面模块的图片和顺序</span>
        </el-form-item>
        <el-form-item label="小程序名称:" prop="appletName" v-if="basicInfo.channelCustomer">
          <el-input v-model="basicInfo.appletName"></el-input>
        </el-form-item>
        <el-form-item label="小程序ID:" prop="appId" v-if="basicInfo.channelCustomer">
          <el-input v-model="basicInfo.appId"></el-input>
        </el-form-item>
        <el-form-item label="小程序密钥:" prop="wxsecret" v-if="basicInfo.channelCustomer">
          <el-input v-model="basicInfo.wxsecret"></el-input>
        </el-form-item>
        <el-form-item label="小程序图标:" v-if="basicInfo.channelCustomer">
          <el-upload action="#" :show-file-list='false' :http-request="(e) => uploadImg(e, 'icon')">
            <el-button type="primary" round>上传</el-button>
          </el-upload>
          <el-image v-show="basicInfo.icon" v-model="basicInfo.icon" style="max-width:200px;margin-top: 10px;" class='yingye' :src="basicInfo.icon" fit="cover" :preview-src-list="[basicInfo.icon]">
          </el-image>
        </el-form-item>
        <el-form-item label="商户Id:" prop="merchantId" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'">
          <el-input v-model="basicInfo.merchantId" placeholder="请输入商户Id"></el-input>
        </el-form-item>
        <el-form-item label="私钥路径:" prop="privateKeyPath" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'">
          <el-input v-model="basicInfo.privateKeyPath" placeholder="请输入私钥路径"></el-input>
        </el-form-item>
        <el-form-item label="证书序列号:" prop="merchantSerialNumber" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'">
          <el-input v-model="basicInfo.merchantSerialNumber" placeholder="请输入证书序列号"></el-input>
        </el-form-item>
        <el-form-item label="APIv3秘钥:" prop="apiV3Key" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'">
          <el-input v-model="basicInfo.apiV3Key" placeholder="请输入APIv3秘钥" maxlength="32"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round style="width: 100px" @click="checkType = false, checkDialog = true">审核拒绝</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="confirmCheck">审核通过</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="checkDialog" width="30%">
      <span>{{ checkType ? '是否确认审核通过？' : '是否确认审核拒绝？' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button type="primary" @click="check">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import uploadWebImg from '@/utils/uploadWebImg'
import { vipStoreQueryByStoreId, vipStoreAuditStore } from '@/api/crm'

export default {
  name: 'check-plateform',
  data () {
    //  var appIdVerify = (rule, value, callback) => {
    //   if (!this.basicInfo.appId) {
    //     callback(new Error('请输入小程序ID'))
    //   } else if (!/^[a-zA-Z0-9]{18}$/.test(this.basicInfo.appId)) {
    //     callback(new Error('请输入由18位数字和字母组成的id'))
    //   } else {
    //     callback()
    //   }
    // }
    // var secretVerify = (rule, value, callback) => {
    //   if (!this.basicInfo.wxsecret) {
    //     callback(new Error('请输入小程序密钥'))
    //   } else if (!/^[a-zA-Z0-9]{18}$/.test(this.basicInfo.wxsecret)) {
    //     callback(new Error('请输入由32位数字和大小写字母组成的秘钥'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      storeMsg: {},
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      basicInfo: {
        diyHomepage: 0,
        address: {
          // fullAddress: ''
        },
        storeTypeBean: {
          id: null
        },
        tbOrder: 0,
        supportVerificationCode: 0,
        dyOrder: 0,
        acquisition: 0, // 是否为获客平台
        agentPrice: 0, // 是否设置代理价格
        cloudPhotographicPlate: 0, // 是否开通云底片
        reservationService: 0 // 是否开通预约服务
      },
      isRepeat: false,
      isCheckedRepeat: false,
      rules: {
        collectionAccount: [
          { required: true, message: '请输入收款账号', trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: '请输入户名', trigger: 'blur' }
        ],
        bank: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        appletName: [
          { required: true, message: '请输入小程序名称', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请输入小程序ID', trigger: 'blur' }
        ],
        wxsecret: [
          { required: true, message: '请输入小程序密钥', trigger: 'blur' }
        ],
        apiV3Key: [
          { max: 32, message: 'APIv3密钥长度不能超过32位', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    }
    let id = this.$route.query.id
    vipStoreQueryByStoreId(id).then((res) => {
      if (res.data.success) {
        let obj = {}
        obj = res.data.data
        obj.sendFlag = obj.sendFlag === undefined ? '1' : obj.sendFlag
        if (!obj.address) {
          obj.address = {}
        }
        if (res.data.data.storeTypeBean === undefined) {
          obj.storeTypeBean = {
            id: ''
          }
        }
        if (obj.wxConfigList.length > 0) {
          this.basicInfo = {
            ...obj,
            appletName: obj.wxConfigList[0].appletName,
            appId: obj.wxConfigList[0].appId,
            wxsecret: obj.wxConfigList[0].wxsecret,
            merchantId: obj.wxConfigList[0].merchantId,
            privateKeyPath: obj.wxConfigList[0].privateKeyPath,
            merchantSerialNumber: obj.wxConfigList[0].merchantSerialNumber,
            apiV3Key: obj.wxConfigList[0].apiV3Key
          }
        } else {
          this.basicInfo = obj
        }
      } else {

      }
    })
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    uploadImg (e, key) {
      console.log(e, key)
      let file = e.file
      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], (e) => {
      }).then(res => {
        if (res === 'error') {
          this.$message.error('服务器问题，请刷新页面重试或联系管理员')
          return
        }
        console.log(res, '11111')
        if (key === 'icon') {
          this.basicInfo.icon = res
        } else {
          // this.basicInfo.licenseUrl = res
        }
        this.$forceUpdate()
      })
    },
    confirmCheck () {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.basicInfo.channelCustomer && !this.basicInfo.icon) {
          this.$message.error('请上传小程序图标')
          return
        }
        this.checkType = true
        this.checkDialog = true
      })
    },
    customerChange (value) {
      console.log(value)
      // if (value === 1) {
      //   this.basicInfo.automaticPayment = 1
      // }
    },
    check () {
      let auditStoreVo = {
        diyHomepage: this.basicInfo.diyHomepage,
        auditStatus: this.checkType ? 'HANDLE' : 'REFUSE',
        id: this.$route.query.id,
        paymentType: this.basicInfo.paymentType,
        channelCustomer: this.basicInfo.channelCustomer,
        supportApp: this.basicInfo.supportApp,
        tbOrder: this.basicInfo.tbOrder,
        supportVerificationCode: this.basicInfo.supportVerificationCode,
        dyOrder: this.basicInfo.dyOrder,
        acquisition: this.basicInfo.acquisition,
        agentPrice: this.basicInfo.agentPrice,
        cloudPhotographicPlate: this.basicInfo.cloudPhotographicPlate, // 是否开通云底片
        reservationService: this.basicInfo.reservationService, // 是否开通预约服务
        automaticPayment: this.basicInfo.automaticPayment,
        wxConfigList: [{
          icon: this.basicInfo.icon,
          appletName: this.basicInfo.appletName,
          appId: this.basicInfo.appId,
          wxsecret: this.basicInfo.wxsecret,
          id: this.basicInfo.wxConfigList.length > 0 ? this.basicInfo.wxConfigList[0].id : '',
          merchantId: this.basicInfo.merchantId,
          privateKeyPath: this.basicInfo.privateKeyPath,
          merchantSerialNumber: this.basicInfo.merchantSerialNumber,
          apiV3Key: this.basicInfo.apiV3Key
        }]
      }
      vipStoreAuditStore(auditStoreVo).then(res => {
        if (res.data.success) {
          this.$message.success('审核成功')
          if (this.checkType) {
            this.storeMsg = res.data.data
            this.checkTrueDialog = true
          } else {
            this.checkDialog = false
          }
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index";

@deep: ~">>>";
</style>
